import * as angular from 'angular';
import { IComponentOptions } from 'angular';
import nvSupportsModule from '../../../_module';
import { SupportStepDescriptionCtrl } from './description-step.controller';

export const DescriptionStepComponent: IComponentOptions = {
  template: require('./description-step.html'),
  bindings: {
    nextStep: '&',
    prevStep: '&',
    currentSupport: '<',
  },
  controller: SupportStepDescriptionCtrl,
};
angular.module(nvSupportsModule).component('descriptionStep', DescriptionStepComponent);
